export const WARNING_FRESHNESS_WINDOW_MS = 2 * 60 * 1000; // 2 minutes
